import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import { BlueButton } from "../../molecules/BlueButton";
import CustomInput from "../../molecules/CustomInput";
import { CartContext } from "../../contex/CartProvider";

const CollapseContent = ({ item }) => {
  const { addToCart } = useContext(CartContext);
  const { register, handleSubmit, reset } = useForm();
  const onSubmit = (data) => {
    const cartItem = {
      count: data.count,
      totalPrice: item.price * data.count,
      ...item,
    };
    addToCart(cartItem, () => {
      alert("item added to cart");
      reset();
    });
    console.log({ data });
  };
  return (
    <div>
      <div className="grid grid-cols-6">
        {/* Image */}
        <div className="py-8 md:py-10 col-span-2">
          <img src={item.details.image} alt="" />
        </div>

        {/* description */}
        <div className="col-span-2 py-4">
          {item.details.features.map((feat, index) => (
            <div
              className="md:w-3/5 m-auto py-3 flex justify-evenly border-b-2 border-light/80"
              key={index}
            >
              <div className="font-bold text-green/80">{feat.title}</div>
              <div className="">{feat.type}</div>
            </div>
          ))}
        </div>

        {/* Button area */}
        <div className="col-span-2 place-self-center">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="w-[80px] m-auto">
              <CustomInput
                register={register}
                id="count"
                required={true}
                type="number"
                min={1}
                placeholder="min. 1"
              />
            </div>
            <BlueButton type="submit">add to cart</BlueButton>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CollapseContent;
